<div class="text-box-container">
  <div class="question-header">
    <h6
      class="m-0 p-0"
      [style.font-size]="questionnaire?.mainContentTemplate?.questionStyle?.fontSize + 'px'"
      [style.font-family]="questionnaire?.mainContentTemplate?.questionStyle?.fontFamily"
      [style.font-weight]="questionnaire?.mainContentTemplate?.questionStyle?.boldStyle"
      [style.color]="questionnaire?.mainContentTemplate?.questionStyle?.fontColor"
    >
      {{ questionNumber }}. {{ question?.question || 'Untitled Question' | titlecase }}
      @if(question?.required) {
      <span
        [style.font-size]="'18px'"
        [style.font-family]="questionnaire?.mainContentTemplate?.errorMessageStyle?.fontFamily"
        [style.font-weight]="questionnaire?.mainContentTemplate?.errorMessageStyle?.boldStyle"
        [style.color]="questionnaire?.mainContentTemplate?.errorMessageStyle?.fontColor"
        >*</span
      >
      }
    </h6>
  </div>

  <div class="question-content-slider">
    <!-- Labels Row -->
    @if(question?.questionSpecificOptions?.labels?.length) {
    <div class="slider-labels">
      @for(label of question?.questionSpecificOptions?.labels || []; track label) {
      <span class="slider-label"
      [style.font-size]="questionnaire?.mainContentTemplate?.choiceStyle?.fontSize + 'px'"
      [style.font-family]="questionnaire?.mainContentTemplate?.choiceStyle?.fontFamily"
      [style.font-weight]="questionnaire?.mainContentTemplate?.choiceStyle?.boldStyle"
      [style.color]="questionnaire?.mainContentTemplate?.choiceStyle?.fontColor"
      >{{ label.text | titlecase }}</span>
      }
    </div>
    }

    <!-- Slider -->
    <div class="slider-container">
      <!-- <span class="slider-min">{{ min }}</span> -->
      <input
        type="range"
        class="slider-input"
        [min]="min"
        [max]="max"
        [value]="value"
        [disabled]="disabled"
        [style.--slider-percentage]="((value - min) / (max - min)) * 100 + '%'"
        (input)="onSliderChange($event)"
        (click)="$event.stopPropagation()"
      />
      <span class="slider-max">{{ value }}</span>
      <!-- <p class="slider-max">{{ value }}</p> -->
    </div>
  </div>
</div>
